// extracted by mini-css-extract-plugin
export default {"inforLeft":"Infor_inforLeft__Ll5sj","avatar":"Infor_avatar__9y45J","icon":"Infor_icon__anNcI","name":"Infor_name__9yxEC","input":"Infor_input__nvGYR"};